import capitalize from 'lodash/capitalize';
import React, { useState } from 'react';
import { Spinner } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { QBOAccountField } from "../../../integrations/QBO/QBOAccountField";
import { useStoreActions } from "../../../store/store-context";
import styles from "./QBOSetupStep.module.scss";
export let LinkType = /*#__PURE__*/function (LinkType) {
  LinkType["Bank"] = "bank";
  LinkType["Expense"] = "expense";
  LinkType["Clearing"] = "clearing";
  return LinkType;
}({});
export function AccountRow(_ref) {
  let {
    linkType,
    initialValue,
    qboAccounts,
    placeholder,
    noOptionsText = 'No QuickBooks accounts'
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [selectedOption, setSelectedOption] = useState(() => qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.find(account => account.id === initialValue));
  const [mapStatus, setMapStatus] = useState(() => selectedOption ? MapStatus.Saved : MapStatus.NotSaved);
  const onChange = async account => {
    if (!account) return;
    setMapStatus(MapStatus.Saving);
    setSelectedOption(account);
    try {
      await api.qbo.linkAccount({
        linkType,
        integratedId: account.id
      });
      setMapStatus(MapStatus.Saved);
    } catch (e) {
      setMapStatus(MapStatus.Failed);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.accountRow,
    "data-testid": "".concat(linkType, "-account-wrapper")
  }, /*#__PURE__*/React.createElement(QBOAccountField, {
    "data-testid": "".concat(linkType, "-account"),
    options: qboAccounts || [],
    onChange: onChange,
    selectedOption: selectedOption,
    textFieldProps: {
      placeholder,
      error: mapStatus === MapStatus.Failed,
      minWidth: 412,
      label: "".concat(capitalize(linkType), " Account")
    },
    noOptionsText: noOptionsText
  }), /*#__PURE__*/React.createElement(SaveStatus, {
    mapStatus: mapStatus
  }));
}
var MapStatus = /*#__PURE__*/function (MapStatus) {
  MapStatus["Saved"] = "saved";
  MapStatus["NotSaved"] = "notSaved";
  MapStatus["Failed"] = "failedToSave";
  MapStatus["Saving"] = "saving";
  return MapStatus;
}(MapStatus || {});
export function SaveStatus(props) {
  const {
    mapStatus
  } = props;
  let element;
  switch (mapStatus) {
    case MapStatus.Saved:
      element = /*#__PURE__*/React.createElement("div", {
        className: styles.mapped,
        "data-testid": "saved"
      }, /*#__PURE__*/React.createElement(Checkmark, null));
      break;
    case MapStatus.NotSaved:
      element = null;
      break;
    case MapStatus.Failed:
      element = null;
      break;
    case MapStatus.Saving:
      element = /*#__PURE__*/React.createElement(Spinner, {
        "data-testid": "save-spinner",
        size: 32
      });
      break;
    default:
      element = null;
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "save-status",
    className: styles.saveStatus
  }, element);
}